// Envia um texto pronto pro WhatsApp. No celular (toque) abre a folha de
// compartilhar nativa, onde o WhatsApp aparece; no computador a folha nativa
// quase nunca lista o WhatsApp, então abre o WhatsApp Web (wa.me) já com a
// mensagem preenchida.
export async function shareText(text) {
  const touch = window.matchMedia("(pointer: coarse)").matches

  if (touch && navigator.share) {
    try {
      await navigator.share({ text })
      return
    } catch (error) {
      // Usuário fechou a folha de compartilhar — nada a fazer.
      if (error.name === "AbortError") return
    }
  }

  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener")
}
